import moment from "moment";
import React from "react";
import "./Footer.css";

const Footer = (props) => {
  const { context } = props;
  return (
    <>
      <footer className="footer pr-2">
        <div className="row">
          <div className="col-lg-6 text-left">
            {/* <p>{props.footerData.text}© </p> */}
            <p
              className={context?.Id ? "note-queries-dashboard" : "note-queries-registration"}
            >{`For any queries, email us at thakur.bharvi@mahindra.com, 022 68135631`}</p>
          </div>
          <div className="col-lg-6 text-right">
            {/* <p>{props.footerData.text}© </p> */}
            <p>Copyright © {moment().format("YYYY")} Mahindra & Mahindra Ltd. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
